module.exports = __webpack_public_path__ + "img/task-board-inquiry2.2790eaa6.png";